module.exports = __webpack_public_path__ + "img/56a0dc1.jpg";